import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  investor_group_type: {
    name: 'Investor Group Type'
  },
  percent_of_nav: {
    name: '% of NAV'
  }
};

export function InvestmentGroup({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_GROUP,
    onChangeFund,
    schema: schema.INVESTOR_GROUP,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.INVESTOR_GROUP?.field_names || [],
    columnLables,
    funds,
    isMultiFunds,
    tableName: 'INVESTOR_GROUP',
    onAddColumn,
    onDeleteColumn,
    order: 220 as any
  });

  return (
    <Table
      id="fca-reporttables-investment-group-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
